import { Column, ModelBase } from 'loca-boot-core'

interface Config {
  /**
   * 组件id
   */
  id: string
  /**
   * 组件名称
   */
  name: string
  /**
   * 组件显示隐藏
   */
  show: boolean
  /**
   * 组件属性
   */
  properties: object
}

/**
 * 组件配置
 */
export class ConfigModel extends ModelBase {
  /**
   * 组件配置
   */
  @Column()
  public components!: Array<Config>
}

/**
 * 配置项
 */
export interface ConfigItem {
  /**
   * 配置key
   */
  key: string
  /**
   * 配置value
   */
  value: string
}
